export default __webpack_public_path__ + "static/media/ERI_Brochure.ed1e5d21.pdf";